import { ethers } from "ethers";
import ERC20 from "../abi/ERC20.json";
import DumpsterSubmissionABI from '../abi/DumpsterSubmission.json';
import { getAddress } from "./get-address";

const networks = [
    { name: "Ethereum", chainId: 1, url: process.env.REACT_APP_ETHEREUM_MAINNET },
    { name: "Base", chainId: 8453, url: process.env.REACT_APP_BASE_MAINNET },
    { name: "Binance Smart Chain", chainId: 56, url: process.env.REACT_APP_BSC_MAINNET },
    { name: "Avalanche", chainId: 43114, url: process.env.REACT_APP_AVALANCHE_MAINNET }
];

 
const getTokenDetails = async (tokenAddress, chainId) => {

    const network = networks.find(net => net.chainId.toString() == chainId.toString());
    if (!network) return null;

    try {
        const provider = new ethers.providers.JsonRpcProvider(network.url);
        const contract = new ethers.Contract(tokenAddress, ERC20.abi, provider);
 
        const [name, symbol, decimals] = await Promise.all([
            contract.name(),
            contract.symbol(),
            contract.decimals()
        ]);
        return { success: true, name, symbol, decimals };
    } catch (error) {
        console.error(`Error fetching token details for ${tokenAddress}:`, error);
        return { success: false }
    }
};


export const fetchDumpsterSubmissions = async () => {

    try {
        let submissions = [];
        let totalSubmissions = 0;
        let totalSubmittedAmount = 0;
        for (const network of networks) {

            const provider = new ethers.providers.JsonRpcProvider(network.url);
            const addresses = getAddress(network.chainId);
            if (!addresses) continue;

            const contract = new ethers.Contract(
                addresses.dumpster_submission,
                DumpsterSubmissionABI.abi,
                provider
            );
            const dumpsterSubmissions = await contract.getTokenSubmissions();

            for (const submission of dumpsterSubmissions) {
                const tokenDetails = await getTokenDetails(submission[0], submission[2]);
                if (tokenDetails.success) {

                    const submissionAmount = parseFloat(submission[1].toString()) / 10 ** tokenDetails.decimals;
                    totalSubmittedAmount = totalSubmittedAmount + parseFloat(submissionAmount);
                    totalSubmissions += 1;
                    submissions.push({ 
                        address: submission[0],
                        name: tokenDetails.name,
                        symbol: tokenDetails.symbol,
                        decimals: tokenDetails.decimals,
                        amount: submissionAmount, 
                        chainId: submission[2].toString()
                    });
                }
            }

        }
        return { success: true, submissions, totalSubmittedAmount, totalSubmissions }
    } catch (e) {
        return { success: false, message: e.message }
    }
};

